import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-4 mt-5">
      <div className="container text-center">
        <p className="mb-1">© {new Date().getFullYear()} JANPRAVAHA SOCIAL FOUNDATION</p>
        <p className="mb-0">
          <i className="bi bi-envelope-fill"></i> <a href="mailto:janpravaha@gmail.com" className="text-light text-decoration-underline">janpravaha@gmail.com</a> | 
          <i className="bi bi-telephone-fill"></i> <a href="tel:+917588346671" className="text-light text-decoration-underline">+91 7588346671</a>
        </p>
        <p className="mb-0">
          <i className="bi bi-geo-alt-fill"></i> SN 120A/120B, Sinhgad Rd, PL- 27, Sarita Elegance, Pune - 411030, Maharashtra, India
        </p>
      </div>
    </footer>
  );
};

export default Footer;
